import { 
  SIGN_IN,
  ADD_ALERT,
  LOG_OUT
} from './types';
import shortId from "shortid";
import axios from 'axios';
import sleektrading from "../apis/sleektrading";

export const signIn = (values) => dispatch => {
    var config = {
    headers: {
      "Content-Type": "multipart/form-data"
    },
  };
  const data = new FormData();
  data.append('email', values.email);
  data.append('password', values.password);
  sleektrading.post("/login", data, config)
    .then(function (response) {
      if (response.data.code == '201') {
        sessionStorage.setItem('isSignedIn', true);
        sessionStorage.setItem('user', JSON.stringify(response.data));
        sessionStorage.setItem('token', response.data.data.token);
        dispatch({
          type: SIGN_IN,
          payload: response.data
        });
      } else if (response.data.code == '200') {
        dispatch({
          type: ADD_ALERT,
          payload: {
            key: shortId.generate(),
            status: 'error',
            color: 'error',
            message: response.data.message,
            errors: {}
          }
        });
      }
    })
    .catch(function (error) {
      dispatch({
        type: ADD_ALERT,
        payload: {
          key: shortId.generate(),
          status: 'error',
          color: 'error',
          message: error,
          errors: {}
        }
      });
    });
}

export const logOut = () => dispatch => {
    dispatch({
        type: LOG_OUT,
    });
}